/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Recipients_LimitInputs */

const en_mail_admin_recipients_limit = /** @type {(inputs: Mail_Admin_Recipients_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can send to at most 500 recipients.`)
};

const de_mail_admin_recipients_limit = /** @type {(inputs: Mail_Admin_Recipients_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es können höchstens 500 Empfänger angeschrieben werden.`)
};

/**
* | output |
* | --- |
* | "You can send to at most 500 recipients." |
*
* @param {Mail_Admin_Recipients_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_recipients_limit = /** @type {((inputs?: Mail_Admin_Recipients_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Recipients_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_recipients_limit(inputs)
	return en_mail_admin_recipients_limit(inputs)
});